import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";

import mahindra from './images/property/mahindra.jpg'

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};
